"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NavItem2 = _interopRequireDefault(require("reactstrap/lib/NavItem"));
var _NavLink2 = _interopRequireDefault(require("reactstrap/lib/NavLink"));
var _react = _interopRequireDefault(require("react"));
var _CornerstoneBadge = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneBadge"));
var _CornerstoneAvatar = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneAvatar"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class NotifyIcon extends _react.default.Component {
  render() {
    if (localStorage.getItem("AppId") === "RDS") {
      return /*#__PURE__*/_react.default.createElement(_NavItem2.default, {
        onClick: e => this.props.onClick(),
        className: "job-alert-nav-item "
      }, /*#__PURE__*/_react.default.createElement(_NavLink2.default, {
        onClick: e => null
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneBadge.default, {
        style: {
          backgroundColor: "#176e9e"
        },
        count: this.props.notifyDetails.completedItemsCount,
        offset: [-20, 6]
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneAvatar.default, {
        className: "top-head-avatar",
        shape: "square",
        size: 40,
        icon: "download"
      }))));
    }
    return null;
  }
}
exports.default = NotifyIcon;